import { render, staticRenderFns } from "./OrderAmount.vue?vue&type=template&id=16f2559c"
import script from "./OrderAmount.vue?vue&type=script&lang=js"
export * from "./OrderAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports